export default __webpack_public_path__ + "static/toolkitHomeVp1-9d2f5e002d3aceae2a1d0e4325e38ba4.png";